// extracted by mini-css-extract-plugin
export var banner = "_r3-0";
export var settingRow = "_r3-2";
export var titleIcon = "_r3-1";